export function filterSpeedRange(feature) {
  if (this.Speeds_mbps) {
    const speedGreaterThan = feature.attributes.Speeds_mbps >= this.Speeds_mbps[0];
    const speedLessThan = feature.attributes.Speeds_mbps <= this.Speeds_mbps[1];
    return speedGreaterThan && speedLessThan;
  }
  return true;
}

export function filterLocations(feature) {
  if (this.Location && this.Location.length) {
    return this.Location.includes(feature.attributes.Location);
  }
  return true;
}

export const dataFilters = {
  filterSpeedRange,
  filterLocations,
};

export default dataFilters;
